import { Stack } from '@mui/material';
import { PAGE_STACK_SPACING } from '../layout/navConfig';

/** Consistent vertical rhythm for page content stacks */
export function PageBody({ children, spacing = PAGE_STACK_SPACING, sx }) {
  return (
    <Stack
      spacing={spacing}
      sx={{
        width: '100%',
        alignItems: 'stretch',
        maxWidth: '100%',
        minWidth: 0,
        '& > *': {
          minWidth: 0,
          maxWidth: '100%',
        },
        ...sx,
      }}
    >
      {children}
    </Stack>
  );
}
